(() => {
  const ROOT_SELECTOR = '.sh-faq-page .enapfaq';
  const QUESTION_SELECTOR = '.singleFaq-enaplist-accordianh';
  const ANSWER_SELECTOR = '.singleFaq-enaplist-accordianb';
  const LOCALE = document.documentElement.lang.toLowerCase().split('-')[0];

  const FAQ_TRANSLATIONS = {
    fr: [
      {
        question: 'Quels moyens de paiement acceptez-vous ?',
        answerHtml:
          '<p>Nous acceptons les paiements par carte bancaire (Visa, Mastercard et American Express), PayPal et Apple Pay.</p>',
      },
      {
        question: 'Puis-je modifier ou annuler ma commande après l’achat ?',
        answerHtml:
          '<p>Vous disposez de 24 heures après votre achat pour demander une modification ou une annulation. Passé ce délai, nous ne pouvons plus garantir de changement, car chaque pièce est produite en quantité limitée. Contactez-nous rapidement à skinnyhippo@skinnyhippo.shop.</p>',
      },
      {
        question: 'Proposez-vous des cartes cadeaux ?',
        answerHtml:
          '<p>Oui, nous proposons des e-cartes cadeaux utilisables sur l’ensemble de nos collections.</p>',
      },
      {
        question: 'Dans quels pays livrez-vous ?',
        answerHtml:
          '<p>Nous livrons dans le monde entier. La livraison, les droits de douane et les taxes sont inclus. Aucun frais à la livraison.</p>',
      },
      {
        question: 'Comment retourner un article ?',
        answerHtml:
          '<p>Nous appliquons une politique de retour de 14 jours. Vous disposez donc de 14 jours après réception de votre article pour demander un retour.</p><p>Pour être admissible à un retour, votre article doit être dans le même état que lorsque vous l’avez reçu : non porté ou non utilisé, avec ses étiquettes et dans son emballage d’origine. Vous aurez également besoin du reçu ou de la preuve d’achat.</p><p>Pour demander un retour, contactez-nous à skinnyhippo@skinnyhippo.shop. Si votre retour est accepté, nous vous enverrons une étiquette de retour ainsi que les instructions d’envoi. Les articles renvoyés sans demande de retour préalable ne seront pas acceptés.</p><p>Vous pouvez nous contacter à cette même adresse pour toute question concernant un retour.</p><p>Veuillez inspecter votre commande dès sa réception et nous contacter immédiatement si l’article est défectueux ou endommagé, ou si vous avez reçu le mauvais article, afin que nous puissions évaluer le problème et y remédier.</p><p><strong>Exceptions et articles non retournables</strong><br>Malheureusement, nous n’acceptons pas les retours d’articles en promotion ni de cartes cadeaux.</p>',
      },
      {
        question: 'Les retours sont-ils gratuits ?',
        answerHtml: '<p>Les frais de retour sont à notre charge.</p>',
      },
      {
        question: 'Comment utiliser le guide des tailles ?',
        answerHtml:
          '<p>Les mesures de nos tableaux correspondent aux dimensions du vêtement fini, non porté. Selon la matière, le vêtement pourra s’étirer et influencer le choix de votre taille ; nous le préciserons toujours sur la fiche produit.</p><p>Votre taille peut varier selon votre morphologie et la coupe du vêtement, mais nous vous indiquerons toujours comment la choisir au mieux, par exemple en vous conseillant de prendre une taille en dessous. Vous pouvez également comparer vos mensurations à notre guide des tailles.</p>',
      },
      {
        question: 'Comment entretenir mes vêtements SkinnyHippo ?',
        answerHtml:
          '<p><strong>Laver à basse température</strong><br>Privilégiez les lavages à basse température. Une chaleur excessive peut accélérer la dégradation des fibres textiles et altérer les couleurs. Nous recommandons un lavage entre 20 °C et 30 °C, avec un essorage de 400 à 800 tours par minute maximum.</p><p><strong>Laver à la main</strong><br>Lavez vos articles à la main dès que possible afin de réduire l’abrasion des tissus. Nous recommandons d’utiliser des produits doux.</p><p><strong>Retourner les vêtements avant le lavage</strong><br>Cela protège les motifs et les détails, tout en limitant le boulochage.</p><p><strong>Utiliser un sac à linge si possible</strong><br>Le sac à linge réduit les frottements entre les différentes matières et contribue à prolonger la durée de vie de vos vêtements.</p><p><strong>Sécher à l’air libre</strong><br>Évitez autant que possible le sèche-linge et privilégiez le séchage à l’air libre.</p><p><strong>Éviter le repassage excessif</strong><br>La chaleur peut endommager les fibres. Si possible, utilisez un défroisseur à vapeur pour limiter l’exposition directe de la matière à la chaleur.</p>',
      },
      {
        question: 'Comment SkinnyHippo soutient-elle la cause animale ?',
        answerHtml:
          '<p>Une partie des bénéfices de chaque collection est reversée à des organisations telles que le WWF afin de contribuer à la protection des espèces menacées.</p>',
      },
      {
        question: 'Comment puis-je vous contacter ?',
        answerHtml:
          '<p>Notre service client est disponible par e-mail à skinnyhippo@skinnyhippo.shop.</p>',
      },
      {
        question: 'Comment être informé des prochains drops ?',
        answerHtml:
          '<p>Suivez-nous sur Instagram (@skinnyhippofficiel) et restez à l’affût des QR codes qui peuvent apparaître dans les rues des grandes métropoles.</p>',
      },
    ],
  };

  const localiseFaqItem = (question, answer, index) => {
    const translation = FAQ_TRANSLATIONS[LOCALE]?.[index];
    if (!translation) return;

    const questionContent = question.querySelector('.enap-qe, p');
    if (questionContent && questionContent.textContent.trim() !== translation.question) {
      questionContent.textContent = translation.question;
    }

    if (!answer) return;

    const answerContent =
      answer.querySelector('.enaparent_faq_0, [class*="enaparent_faq"]') || answer;

    if (answerContent.innerHTML.trim() !== translation.answerHtml) {
      answerContent.innerHTML = translation.answerHtml;
    }
  };

  const enhanceFaq = (root) => {
    const vendorLink = root.querySelector('a[href*="apps.shopify.com/partners/enormapps"]');
    vendorLink?.closest('div')?.remove();

    const questions = [...root.querySelectorAll(QUESTION_SELECTOR)];

    questions.forEach((question, index) => {
      const answer = question.nextElementSibling?.matches(ANSWER_SELECTOR)
        ? question.nextElementSibling
        : root.querySelector(`#${CSS.escape(question.id.replace('enapfaq_', 'enapfaqAns_'))}`);

      localiseFaqItem(question, answer, index);

      if (question.dataset.shFaqQuestionReady === 'true') return;

      question.dataset.shFaqQuestionReady = 'true';

      if (!question.id) question.id = `skinny-faq-question-${index + 1}`;
      if (answer && !answer.id) answer.id = `skinny-faq-answer-${index + 1}`;

      question.setAttribute('role', 'button');
      question.setAttribute('tabindex', '0');
      question.setAttribute('aria-expanded', question.classList.contains('enapalong') ? 'true' : 'false');

      if (answer) {
        question.setAttribute('aria-controls', answer.id);
        answer.setAttribute('role', 'region');
        answer.setAttribute('aria-labelledby', question.id);
      }

      question.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        question.click();
      });
    });

    root.querySelectorAll(QUESTION_SELECTOR).forEach((question) => {
      question.setAttribute('aria-expanded', question.classList.contains('enapalong') ? 'true' : 'false');
    });
  };

  const initialiseFaq = (root) => {
    if (!root || root.dataset.shFaqReady === 'true') return;

    root.dataset.shFaqReady = 'true';
    enhanceFaq(root);

    new MutationObserver(() => enhanceFaq(root)).observe(root, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true,
    });
  };

  const findFaq = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;
    initialiseFaq(root);
    return true;
  };

  if (!findFaq()) {
    const appObserver = new MutationObserver(() => {
      if (!findFaq()) return;
      appObserver.disconnect();
    });

    appObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
